const normalizedBasePath = (process.env.VUE_APP_STORAGE_BASE_PATH || "portfolio")
  .replace(/^\/+|\/+$/g, "");

const withBasePath = (path) =>
  normalizedBasePath ? `${normalizedBasePath}/${path}` : path;

export const storageFolders = {
  homeCarousel: withBasePath("home/coverpage"),
  features: withBasePath("home/features"),
  projectsLandscape: withBasePath("projects/landscape"),
  projectsPortrait: withBasePath("projects/portrait"),
  contactCards: withBasePath("contact/cards"),
  footer: withBasePath("footer"),
};

export const storageFiles = {
  logoIcon: withBasePath("branding/logo/logo_new.png"),
  logoWordmark: withBasePath("branding/logo/logo_name.png"),
  splashMain: withBasePath("branding/splash/logo_and_name.jpeg"),
  splashFooter: withBasePath("branding/splash/splash_footer.jpeg"),
};
